export class TimeManagerTeam {
  Id: number;
  RecordId: number;
  ManagerId: number;
  TeamId: number;
  CreatedBy: number;
  CreatedDate?: string;
  ModifiedBy?: number;
  ModifiedDate?: string;
  IsDeleted: boolean;

  constructor(obj?: Partial<TimeManagerTeam>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }
}
